import { cloneDeep } from "lodash";
import { comparisonAliases } from "common/constants";
const addFieldSufix = (totals, comparisonEntity, columnsToTriple, dimension) => {
    for (const total of totals) {
        for (const [key, value] of Object.entries(total)) {
            if (columnsToTriple.includes(key) && key !== dimension && key !== "ReferenceDate") {
                const newKey = `${key}${comparisonEntity}`;
                total[newKey] = value;
                delete total[key];
            }
        }
    }
};
export const addFieldSufixes = (mainPortfolioTotals, comparisonPortfolioTotals, differenceTotals, columnsToTriple, differenceEntityAlias, dimension) => {
    addFieldSufix(mainPortfolioTotals, comparisonAliases.main, columnsToTriple, dimension);
    addFieldSufix(comparisonPortfolioTotals, comparisonAliases.comparate(0), columnsToTriple, dimension);
    addFieldSufix(differenceTotals, differenceEntityAlias, columnsToTriple, dimension);
};
export const combineComparisonRows = (mainPortfolioTotals, comparisonPortfolioTotals, differenceTotals, dimension) => {
    const output = [];
    if (differenceTotals.length === 1) {
        return [{ ...differenceTotals[0], ...comparisonPortfolioTotals[0], ...mainPortfolioTotals[0] }];
    }
    for (const difTotal of differenceTotals) {
        const groupByDimension = difTotal[dimension];
        output.push({ ...difTotal,
            ...mainPortfolioTotals.find((x) => x[dimension] === groupByDimension),
            ...comparisonPortfolioTotals.find((x) => x[dimension] === groupByDimension) });
    }
    return output;
};
const createColumns = (column, pflName, comparisonPflName) => {
    const output = [cloneDeep(column), cloneDeep(column), cloneDeep(column)];
    output[0].headerName = `${pflName ?? "Portfolio A"} ${output[0].headerName}`;
    output[1].headerName = `${comparisonPflName ?? "Portfolio B"} ${output[1].headerName}`;
    output[2].headerName = `${output[2].headerName} difference`;
    if (output[0].children) {
        output[0].children.forEach((x) => {
            x.field = `${column.field}${comparisonAliases.main}.${x.field?.split(".")[1]}`;
        });
        output[1]?.children?.forEach((x) => {
            x.field = `${column.field}${comparisonAliases.comparate(0)}.${x.field?.split(".")[1]}`;
        });
        output[2]?.children?.forEach((x) => {
            x.field = `${column.field}${comparisonAliases.diff(comparisonAliases.main, comparisonAliases.comparate(0))}.${x.field?.split(".")[1]}`;
        });
    }
    output[0].field = `${column.field}${comparisonAliases.main}`;
    output[1].field = `${column.field}${comparisonAliases.comparate(0)}`;
    output[2].field = `${column.field}${comparisonAliases.diff(comparisonAliases.main, comparisonAliases.comparate(0))}`;
    return output;
};
export const createColumnsForComparisonGrid = (columns, columnsToTriple, mainPflName, comparisonPflName, dimension) => {
    const columnsToRemove = [];
    const columnsToAdd = [];
    columns.forEach((column) => {
        if (columnsToTriple.includes(column.field || "") && column.field !== dimension && column.field !== "ReferenceDate") {
            columnsToAdd.push(...createColumns(column, mainPflName, comparisonPflName));
            columnsToRemove.push(column.field || "");
        }
    });
    columnsToRemove.forEach((value) => {
        columns.splice(columns.findIndex((x) => x.field === value), 1);
    });
    columns.push(...columnsToAdd);
};
